<template>
  <header class="simple-header">
    <router-link :to="{ name: 'home' }">
      <img
        src="/img/logo.png"
        alt="Logo"
      >
    </router-link>
  </header>
</template>
<script>
// @group Layout
// Site Header
export default {
  name: 'simple-header',
};
</script>
<style lang="scss">
.simple-header {
  height: 50vh;
  padding: 3vh 3vh 0;
  width: auto;
  font-size: 0;
  transition: height 0.1s linear;
  text-align: center;
  user-select: none;
  & > a {
    display: block;
    height: 100%;
    font-size: 0;
    img {
      width: auto !important;
      height: 100%;
      max-width: 100%;
    }
  }
}
</style>
